import { useMutation } from 'react-relay';

import { saveRefundActionLogMutation } from '@/__generated__/saveRefundActionLogMutation.graphql';
import { saveRefundActionLog } from '@/graphql/mutation/taxRefund/saveRefundActionLog';

const useSaveRefundActionLog = () => {
  const [commit, isInFlight] = useMutation<saveRefundActionLogMutation>(saveRefundActionLog);

  return { commit, isInFlight };
};

export default useSaveRefundActionLog;
